export default class LeadModel {
  id!: number;

  descricao!: string;
}
